/* Carrito drawer lateral (estilo CasDeia) — vanilla JS */
(function () {
  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-overlay');
  const closeBtn = document.getElementById('cart-close');
  const itemsEl = document.getElementById('cart-items');
  const subtotalEl = document.getElementById('cart-subtotal');
  const countEl = document.getElementById('cart-count');
  const recTrack = document.getElementById('cart-rec-track');
  if (!drawer) return;

  // variantes que son regalo (las mete assets/cronier-regalo.js)
  const REGALO_CADENA = 58942435230041;
  const REGALOS = [58942435230041, 58942439031129];
  // Formato de la referencia: entero + simbolo pegado, sin decimales ni coma.
  // El simbolo NO va fijo: la tienda tiene mercado de Reino Unido en libras y el carrito
  // debe respetarlo igual que la rejilla. Antes decia siempre '€', asi que en UK los
  // importes eran correctos (/cart.js ya devuelve GBP) pero se pintaban con el simbolo
  // equivocado. La moneda sale de Shopify.currency.active y se refresca con cada
  // respuesta de /cart.js, que es la fuente de verdad del mercado activo.
  let MONEDA = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
  // sin redondear: 39,90 se muestra 39,90, no 40. Un importe exacto se pinta sin
  // los dos ceros (45€), que no es lo mismo que redondear.
  const money = (cents) => {
    const ent = Math.floor(cents / 100), dec = cents % 100;
    if (MONEDA === 'GBP') return dec ? '£' + ent + '.' + String(dec).padStart(2, '0') : '£' + ent;
    return dec ? ent + ',' + String(dec).padStart(2, '0') + '€' : ent + '€';
  };

  // Imagen de producto: se prefiere SIEMPRE el PNG recortado (mismo tratamiento que la
  // rejilla y la ficha). window.GZ_CUT lo publica layout/theme.liquid, porque la URL de un
  // asset del tema solo la sabe resolver Liquid. Respaldo: la foto de Shopify.
  const imagenDe = (handle, respaldo) => (window.GZ_CUT && window.GZ_CUT[handle]) || respaldo || '';

  // Precio de comparacion (el tachado). /cart.js NO lo devuelve: sus campos de precio son
  // los del carrito (descuentos aplicados), no el compare_at del catalogo. Se pide a
  // /products/<handle>.js, que si lo trae por variante. Mismo patron que las
  // recomendaciones, que ya leen products.json. Se cachea por handle: un carrito repinta
  // muchas veces (cada +/- llama a refreshCart) y no queremos una peticion por repintado.
  const _comparaCache = {};
  async function comparaDe(handle) {
    if (handle in _comparaCache) return _comparaCache[handle];
    try {
      const d = await fetch('/products/' + handle + '.js').then((r) => r.json());
      const porVariante = {};
      (d.variants || []).forEach((v) => { porVariante[v.id] = Number(v.compare_at_price) || 0; });
      _comparaCache[handle] = porVariante;
    } catch (err) {
      _comparaCache[handle] = {};   // sin red o producto borrado: se pinta sin tachado
    }
    return _comparaCache[handle];
  }

  // Bloqueo de scroll robusto (iOS incl.): fija el body para que el fondo NO se mueva.
  // Solo el carrito hace scroll cuando está abierto.
  let _scrollY = 0;
  function lockScroll() {
    _scrollY = window.scrollY || document.documentElement.scrollTop || 0;
    const bs = document.body.style;
    bs.position = 'fixed'; bs.top = (-_scrollY) + 'px'; bs.left = '0'; bs.right = '0';
    bs.width = '100%'; bs.overflow = 'hidden';
  }
  function unlockScroll() {
    const bs = document.body.style;
    bs.position = ''; bs.top = ''; bs.left = ''; bs.right = ''; bs.width = ''; bs.overflow = '';
    window.scrollTo(0, _scrollY);
  }

  // ── OPEN / CLOSE ──
  function openCart() {
    drawer.classList.add('open');
    overlay && overlay.classList.add('open');
    lockScroll();
    drawer.setAttribute('aria-hidden', 'false');
    refreshCart();
    loadRecommendations();
  }
  window.GZ_openCart = openCart; // para abrirlo desde el selector
  // Lo usa assets/cronier-regalo.js: cuando añade las lineas de regalo necesita que el
  // panel se repinte, porque el repintado propio del tema ya ha ocurrido antes.
  window.GZ_refreshCart = refreshCart;
  function closeCart() {
    drawer.classList.remove('open');
    overlay && overlay.classList.remove('open');
    unlockScroll();
    drawer.setAttribute('aria-hidden', 'true');
  }

  // Intercepta el icono del carrito (no navega a /cart)
  document.querySelectorAll('[data-cart-toggle], .hdr-cart, a[href="/cart"], a[href$="/cart"]').forEach((el) => {
    el.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  });
  closeBtn && closeBtn.addEventListener('click', closeCart);
  overlay && overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });

  // ── CUENTA ATRAS DEL BANNER ──
  // No calcula nada por su cuenta: lee window.GZ_OFERTA, la misma fuente que usa la barra
  // superior (la publica sections/cf-announcement.liquid). Asi los dos relojes marcan
  // exactamente lo mismo. Si no existe, el banner se queda con el texto de envio.
  (function relojCarrito() {
    var caja = document.getElementById('cart-oferta');
    var reloj = document.getElementById('cart-reloj');
    if (!caja || !reloj) return;
    var oferta = window.GZ_OFERTA;
    if (!oferta) {
      var txt = caja.querySelector('.cart-drawer__banner-txt');
      if (txt) txt.textContent = caja.dataset.fallback || '';
      reloj.remove();
      return;
    }
    function dosCifras(n) { return n < 10 ? '0' + n : String(n); }
    function pinta() {
      var q = Math.max(0, oferta.restante());
      reloj.textContent = dosCifras(Math.floor(q / 3600)) + ':' +
                          dosCifras(Math.floor((q % 3600) / 60)) + ':' +
                          dosCifras(q % 60);
    }
    pinta();
    setInterval(pinta, 1000);
  })();

  // ── CARGAR CARRITO ──
  async function refreshCart() {
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      await renderItems(cart);
    } catch (err) { console.error('Cart fetch error:', err); }
  }

  function updateBadges(count) {
    if (countEl) countEl.textContent = count;
    // badge del header
    document.querySelectorAll('.cart-count').forEach((b) => { b.textContent = count; b.style.display = count > 0 ? '' : 'none'; });
  }

  async function renderItems(cart) {
    // /cart.js confirma la moneda del mercado activo en cada respuesta
    if (cart && cart.currency) MONEDA = cart.currency;
    updateBadges(cart.item_count);
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    if (!itemsEl) return;

    if (!cart.items.length) {
      itemsEl.innerHTML = '<div style="padding:48px 0;text-align:center;color:#999;font-size:13px;font-weight:600;letter-spacing:.08em;text-transform:uppercase">' + ((window.GZ_T && window.GZ_T.vacio) || 'Your cart is empty') + '</div>';
      return;
    }

    // Ordena: la parte de ARRIBA (top) primero, la de ABAJO (bottom) después
    // Precarga de los precios de comparacion ANTES de pintar, para que el tachado
    // aparezca de golpe con el resto de la linea y no haya parpadeo.
    const comparas = {};
    await Promise.all(
      Array.from(new Set(cart.items.map((i) => i.handle)))
        .map(async (h) => { comparas[h] = await comparaDe(h); })
    );

    // Los REGALOS van al final: el cliente tiene que ver arriba lo que ha comprado.
    // Antes salian primero porque /cart/add.js los coloca delante al añadirlos despues.
    const esRegalo = (it) => REGALOS.indexOf(it.variant_id) !== -1;
    const ord = (it) => {
      if (it.variant_id === REGALO_CADENA) return 8;   // la cadena antes que la herramienta
      if (esRegalo(it)) return 9;
      const p = (it.properties && (it.properties['Pieza'] || '')) + '';
      return /Arriba/i.test(p) ? 0 : (/Abajo/i.test(p) ? 2 : 1);
    };
    const list = cart.items.slice().sort((a, b) => ord(a) - ord(b));
    itemsEl.innerHTML = list.map((item) => {
      const img = imagenDe(item.handle, item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_220x$1$2') : '');
      // Mostrar la talla EUROPEA que eligió el cliente (va en la propiedad "Pieza" entre paréntesis),
      // no la variante CJ (que es una talla mayor para el proveedor).
      var _piece = (item.properties && item.properties['Pieza']) || '';
      var _web = (_piece.match(/\(([^)]+)\)\s*$/) || [])[1];
      const size = _web || ((item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '');
      // Tachado: compare_at por unidad x cantidad, para que las dos cifras sean de linea
      // y se puedan comparar. Solo se pinta si de verdad es mayor que lo que se paga.
      var _cmpUd = (comparas[item.handle] || {})[item.variant_id] || 0;
      var _cmpLinea = _cmpUd * item.quantity;
      // Una linea de regalo no tiene compare_at, pero SI tiene original_line_price
      // mayor que el final (lo baja el descuento automatico). Se toma el mayor de los
      // dos para que el tachado salga igual en rebajas y en regalos.
      var _base = Math.max(_cmpLinea, item.original_line_price || 0);
      var _antes = _base > item.final_line_price
        ? '<del class="cart-item__antes">' + money(_base) + '</del>' : '';
      return (
        '<div class="cart-item" data-key="' + item.key + '">' +
          '<img class="cart-item__img" src="' + img + '" alt="' + (item.product_title || '') + '">' +
          '<div class="cart-item__info">' +
            '<div class="cart-item__name">' + item.product_title + '</div>' +
            (size ? '<div class="cart-item__variant">' + ((window.GZ_T && window.GZ_T.talla) || 'Talla') + ' ' + size + '</div>' : '') +
            '<div class="cart-item__price">' + money(item.final_line_price) + _antes + '</div>' +
            '<div class="cart-item__qty">' +
              '<button class="cart-item__qty-btn" data-action="decrease" data-key="' + item.key + '">&minus;</button>' +
              '<span class="cart-item__qty-num">' + item.quantity + '</span>' +
              '<button class="cart-item__qty-btn" data-action="increase" data-key="' + item.key + '">+</button>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    itemsEl.querySelectorAll('.cart-item__qty-btn').forEach((btn) => {
      btn.addEventListener('click', async function () {
        const key = this.dataset.key;
        const item = cart.items.find((i) => i.key === key);
        if (!item) return;
        const newQty = this.dataset.action === 'increase' ? item.quantity + 1 : Math.max(0, item.quantity - 1);
        await updateCartItem(key, newQty);
      });
    });
  }

  async function updateCartItem(key, quantity) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      refreshCart();
    } catch (err) { console.error('Cart update error:', err); }
  }

  // ── YOU MAY LIKE ──

  // set-handle -> [variante M ARRIBA, variante M ABAJO] (prendas individuales, modelo diseccionado)
  const SET_BUNDLE = {
    'fc-98-cream-camo-set': ['58366510170457', '58366512005465'],
    'fc-98-cream-western-grey-set': ['58366510170457', '58366511677785'],
    'fc-98-navy-western-black-set': ['58366510301529', '58366511808857'],
    'skeleton-black-camo-set': ['58366510563673', '58366512005465'],
    'skeleton-cream-camo-set': ['58366510432601', '58366512005465'],
    'skeleton-black-western-grey-set': ['58366510563673', '58366511677785'],
    'knight-black-camo-set': ['58366510858585', '58366512005465'],
    'knight-white-western-black-set': ['58366510694745', '58366511808857'],
    'knight-black-western-grey-set': ['58366510858585', '58366511677785'],
    'check-camel-camo-set': ['58366511087961', '58366512005465'],
    'check-carbon-camo-set': ['58366511219033', '58366512005465'],
    'check-camel-western-black-set': ['58366511087961', '58366511808857'],
    'check-carbon-western-black-set': ['58366511219033', '58366511808857'],
    'pocket-polo-white-camo-set': ['58366511382873', '58366512005465'],
    'pocket-polo-black-camo-set': ['58366511546713', '58366512005465'],
    'pocket-polo-white-western-black-set': ['58366511382873', '58366511808857'],
    'pocket-polo-black-western-grey-set': ['58366511546713', '58366511677785']
  };

  function addedFeedback(btn) {
    if (btn) { btn.classList.remove('qa-pop'); void btn.offsetWidth; btn.classList.add('qa-pop'); }
    document.querySelectorAll('.cart-count').forEach(function (b) { b.classList.remove('pulse'); void b.offsetWidth; b.classList.add('pulse'); });
    var d = document.getElementById('cart-toast');
    if (!d) { d = document.createElement('div'); d.id = 'cart-toast'; document.body.appendChild(d); }
    d.textContent = 'Añadido al carrito ✓';
    d.classList.remove('show'); void d.offsetWidth; d.classList.add('show');
    clearTimeout(d._t); d._t = setTimeout(function () { d.classList.remove('show'); }, 1600);
  }

  async function quickAdd(btn) {
    const pair = SET_BUNDLE[btn.dataset.handle];
    try {
      if (pair) {
        await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [
          { id: pair[0], quantity: 1, properties: { 'Conjunto': 'GradaZone', 'Pieza': 'Arriba' } },
          { id: pair[1], quantity: 1, properties: { 'Conjunto': 'GradaZone', 'Pieza': 'Abajo' } }
        ] }) });
      } else if (btn.dataset.variant) {
        await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: btn.dataset.variant, quantity: 1 }) });
      }
      addedFeedback(btn);
    } catch (err) { console.error('quickadd', err); }
    refreshCart();
  }

  // Recomendados del carrito, SEGUN LA CATEGORIA de lo que ya hay dentro.
  // Antes salian siempre de d001 (las chanclas), asi que a quien metia una bandolera se
  // le recomendaban seis pares de chanclas. Ahora manda la categoria dominante del
  // carrito y la otra linea solo aparece como cola.
  //
  // Historial del bug anterior: la coleccion apuntaba a 'new-in' (vaciada al archivar los
  // 90 productos de SORTTEZ) y luego a 'camisetas-de-futbol' (tambien archivados). En los
  // dos casos products.json devolvia [] y el carrusel salia en blanco, sin error.
  // Cronier. Antes eran { bandolera:'b002', chancla:'d001' }: recomendaba bandoleras y
  // chanclas, productos que ya no se promocionan.
  const LINEAS = { bandolera: 'b002', chancla: 'd001' };
  // los regalos no se recomiendan: ya entran solos y a 0 €
  const NO_RECOMENDAR = [];   // los regalos de reloj ya no existen
  const COLA = 4;                       // cuantos productos de la otra linea se dejan al final

  // La categoria sale de product_type, que /cart.js ya devuelve: 'Bandolera' o 'Slide'.
  async function lineaDominante() {
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      // Si ya lleva reloj, lo util es enseñarle joyeria; si no, enseñarle relojes.
      // Criterio de GradaZone: se recomienda la MISMA categoria que ya hay en el
      // carrito. Quien mete una bandolera quiere ver mas bandoleras, no chanclas.
      const hayChancla = (cart.items || []).some((it) => /slide/i.test(it.product_type || ''));
      const hayBolso = (cart.items || []).some((it) => /bandolera/i.test(it.product_type || ''));
      if (hayBolso) return 'bandolera';
      if (hayChancla) return 'chancla';
    } catch (err) { /* carrito vacio o sin red: se cae al valor por defecto */ }
    return 'bandolera';                 // por defecto, la linea principal
  }

  async function productosDe(handle, limite) {
    try {
      const d = await fetch('/collections/' + handle + '/products.json?limit=' + limite).then((r) => r.json());
      return d.products || [];
    } catch (err) { return []; }
  }

  async function loadRecommendations() {
    if (!recTrack) return;
    const linea = await lineaDominante();
    if (recTrack.dataset.loaded === linea) return;   // ya pintado para esta categoria
    try {
      const principal = await productosDe(LINEAS[linea], 20);
      const otra = await productosDe(linea === 'chancla' ? LINEAS.bandolera : LINEAS.chancla, COLA);
      const lista = principal.concat(otra.slice(0, COLA))
        .filter((p) => NO_RECOMENDAR.indexOf(p.handle) === -1);
      const cards = lista.map((p) => {
        const img = imagenDe(p.handle, (p.images[0] && p.images[0].src) || '');
        const mv = (p.variants || []).find((v) => /(^|[^A-Z])M($|[^A-Z])/.test(v.title)) || p.variants[0] || {};
        return (
          '<div class="cart-rec__item">' +
            '<a class="cart-rec__thumb" href="/products/' + p.handle + '" title="' + p.title + '"><img src="' + img + '" alt="' + p.title + '" loading="lazy" draggable="false"></a>' +
            '<button class="cart-rec__quickadd" data-handle="' + p.handle + '" data-variant="' + (mv.id || '') + '" aria-label="Añadir">+</button>' +
          '</div>'
        );
      }).join('');
      recTrack.innerHTML = cards + cards; // duplicado para el bucle infinito
      recTrack.dataset.loaded = linea;    // guarda la categoria, no un simple 'true':
                                          // si el carrito cambia de linea hay que repintar
      setupCarousel();
    } catch (err) { console.error('Recommendations error:', err); }
  }

  // Carrusel de recomendados.
  // La mecanica (bucle infinito, arrastre, pausa al tocar, salto con flecha) vive ahora en
  // assets/gz-carrusel.js, compartida con el selector de colores del hero: era el mismo
  // comportamiento escrito dos veces. Aqui solo queda lo especifico del carrito, que es
  // que hacer cuando el cliente toca una miniatura.
  function setupCarousel() {
    if (!recTrack || typeof window.GZ_carrusel !== 'function') return;
    window.GZ_carrusel(recTrack, {
      itemSel: '.cart-rec__item',
      hueco: 10,
      onTap: function (el) {
        var add = el.closest && el.closest('.cart-rec__quickadd');
        if (add) { quickAdd(add); return true; }
        var th = el.closest && el.closest('.cart-rec__thumb');
        if (th && th.getAttribute('href')) { window.location.href = th.getAttribute('href'); return true; }
        return false;
      },
    });
  }

  // Flechas del carrusel.
  // No tocan `transform` directamente: eso ya fallo una vez, porque el bucle de animacion
  // lo reescribe en cada frame y el salto se borraba antes de verse. Mueven el `offset`
  // del propio bucle a traves de track._empujar(±1), que expone gz-carrusel.js.
  const prevBtn = document.querySelector('.cart-rec__prev');
  const nextBtn = document.querySelector('.cart-rec__next');
  function empujar(dir) {
    if (recTrack && typeof recTrack._empujar === 'function') recTrack._empujar(dir);
  }
  prevBtn && prevBtn.addEventListener('click', () => empujar(-1));
  nextBtn && nextBtn.addEventListener('click', () => empujar(1));

  // ── AUTO-ABRIR tras add to cart ──
  document.addEventListener('submit', async function (e) {
    const form = e.target.closest('form[action="/cart/add"], form[action$="/cart/add"]');
    if (!form) return;
    // No interceptar los botones de pago dinámico (Shop Pay / PayPal / GPay)
    if (e.submitter && e.submitter.getAttribute('name') !== 'add') return;
    e.preventDefault();
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
      if (!res.ok) { const t = await res.json().catch(() => ({})); console.error('Add error', t); }
      openCart();
    } catch (err) { console.error('Add to cart error:', err); }
  });
})();
